module.exports = __webpack_public_path__ + "img/undertakingCases24.c392e43c.jpg";